import { useIntl } from '@leagueplatform/locales';
import {
  PRODUCT_AREA,
  SUB_PRODUCT_AREA,
  usePageViewAnalytics,
} from '@leagueplatform/analytics';
import { getModulePath, LEAGUE_MODULE_NAMES } from '@leagueplatform/core';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { UserAchievements } from '@leagueplatform/rewards-achievements';
import {
  ErrorState,
  PageContainer,
  PageHeader,
} from '@leagueplatform/web-common-components';

export const AchievementsPage = () => {
  const { formatMessage } = useIntl();
  const heading = formatMessage({ id: 'STR_ACHIEVEMENTS' });
  usePageViewAnalytics({
    product_area: PRODUCT_AREA.REWARDS,
    sub_product_area: SUB_PRODUCT_AREA.ACHIEVEMENTS,
    screen_name: 'achievements',
  });
  useDocumentTitle(heading);

  return (
    <>
      <PageHeader
        heading={heading}
        backButton={{
          show: true,
          fallbackUrl: getModulePath(LEAGUE_MODULE_NAMES.healthJourney),
        }}
      />
      <PageContainer css={{ paddingBlockStart: '$two' }}>
        <UserAchievements
          errorComponent={<ErrorState hideImage error={null} />}
        />
      </PageContainer>
    </>
  );
};
